import React, {Component, useState, useEffect} from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Desktop from "./Desktop/Desktop";
import Mobile from "./Mobile/Mobile";
import Download from "./Desktop/Download";
import Feedback from "./Desktop/Feedback";
import TermOfUse from "./Desktop/TermOfUse";
import Privacy from "./Desktop/Privacy";
import Register from "./Desktop/Register";

import {ArcElement, Chart as ChartJS, Legend, Tooltip} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const ResponsiveHome = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

	// 监听窗口大小变化
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 900);
		};

		window.addEventListener('resize', handleResize);

		// 组件卸载时移除事件监听
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	// 根据窗口大小返回对应组件
	return isMobile ? <Mobile /> : <Desktop />;
};
class App extends Component {

	render() {
		// const path = window.location.pathname
		// if (path.indexOf('download') >= 0) {
		// 	if (window.innerWidth < 900) {
		// 		return (<Download/>);
		// 	} else {
		// 		return (<Download/>);
		// 	}
		// }
		// if (path.indexOf('feedback') >= 0) {
		// 	return (<Feedback/>);
		// }
		// if (path.indexOf('tou') >= 0) {
		// 	return (<TermOfUse/>);
		// }
		// if (path.indexOf('privacy') >= 0) {
		// 	return (<Privacy/>);
		// }
		// if (path.indexOf('register') >= 0) {
		// 	return (<Register/>);
		// }
		// if (window.innerWidth < 900) {
		// 	return (<Mobile/>);
		// } else {
		// 	return (<Desktop/>);
		// }

		return (
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<ResponsiveHome />} />
					<Route path="/privacy" element={<Privacy />} />
					<Route path="/feedback" element={<Feedback />} />
					<Route path="/register" element={<Register />} />
					<Route path="/tou" element={<TermOfUse />} />
					<Route path="*" element={<ResponsiveHome />} />
				</Routes>
			</BrowserRouter>
		);
	}
}

export default App;
